import { WaypointActionType, WaypointActionStatusName } from '@caresend/types';
import { getOptionalErrors, getNonEmptyStringErrors, getArrayErrors, getByIdErrors, buildStatusEnumErrorGetter, buildStringEnumErrorsGetter, getNumberErrors, getElementTimestampErrors, getBooleanErrors } from './helpers.js';
import { getKeyValidationErrors } from './validation.js';

const isMailInAction = waypointAction => {
  const typeMatches = waypointAction.type === WaypointActionType.MAIL_IN;
  const hasPlaceGroupID = !!waypointAction.placeGroupID;
  const hasShipments = !!waypointAction.shipments;
  return typeMatches && hasPlaceGroupID && hasShipments;
};

const getWaypointActionDurationErrors = duration => duration ? getKeyValidationErrors(duration, {
  actionDuration: getNumberErrors,
  incrementPerAction: getOptionalErrors(getNumberErrors),
  observationTime: getOptionalErrors(getNumberErrors)
}) : 'Expected an object for waypointAction.duration';

const waypointActionValidationKeys = {
  duration: getWaypointActionDurationErrors,
  id: getNonEmptyStringErrors,
  instructions: getOptionalErrors(getNonEmptyStringErrors),
  itineraryID: getOptionalErrors(getNonEmptyStringErrors),
  mailInWaypointID: getOptionalErrors(getNonEmptyStringErrors),
  placeGroupID: getOptionalErrors(getNonEmptyStringErrors),
  prerequisiteActions: getOptionalErrors(getArrayErrors(preReqAction => getKeyValidationErrors(preReqAction, {
    id: getNonEmptyStringErrors,
    expiryTime: getNumberErrors
  }))),
  procedures: getOptionalErrors(getByIdErrors(getElementTimestampErrors)),
  shipments: getOptionalErrors(getByIdErrors(getBooleanErrors)),
  status: buildStatusEnumErrorGetter(WaypointActionStatusName),
  type: buildStringEnumErrorsGetter(WaypointActionType),
  waypointID: getOptionalErrors(getNonEmptyStringErrors)
};
const partialWaypointActionValidationKeys = Object.assign(Object.assign({}, waypointActionValidationKeys), {
  duration: getOptionalErrors(getWaypointActionDurationErrors),
  id: getOptionalErrors(getNonEmptyStringErrors),
  status: getOptionalErrors(buildStatusEnumErrorGetter(WaypointActionStatusName)),
  type: getOptionalErrors(buildStringEnumErrorsGetter(WaypointActionType))
});
const getWaypointActionValidationErrors = waypointAction => getKeyValidationErrors(waypointAction, waypointActionValidationKeys);
const getPartialWaypointActionValidationErrors = waypointAction => getKeyValidationErrors(waypointAction, partialWaypointActionValidationKeys);

export { getPartialWaypointActionValidationErrors, getWaypointActionValidationErrors, isMailInAction };
